import { globalStyles } from "consts/spaces";
import styled from "styled-components";

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid var(--Color-Border-Disabled, rgba(9, 30, 66, 0.06));
  position: relative;
  margin-top: 48px;
  min-height: 69px;
  padding-top: 24px;

  a {
    margin: ${globalStyles.spaces[50]};
    width: 40px;
    height: 40px;
    background-color: ${(props) => props.theme.colorBackgroundNeutralSubtle};
    color: ${(props) => props.theme.colorTextPrimary};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    &.invisible {
      opacity: 0;
      touch-action: none;
      pointer-events: none;
    }

    &.left {
      position: absolute;
      right: 1.5rem;
      width: auto;
      color: #e50045 !important;
      gap: 0.5rem;
      background: transparent !important;
      letter-spacing: 0.64px;

      &:first-child {
        left: 1.5rem;
        right: auto;
      }
    }

    &.active,
    &:hover {
      background-color: ${(props) => props.theme.colorPrimaryRed};
      color: ${(props) => props.theme.colorTextInverse};
    }

    @media (max-width: ${globalStyles.breackPoints.mobile}) {
      &:not(.left) {
        display: none;
      }
    }
  }

  @media (max-width: 1247px) {
    margin-top: 40px;
  }

  @media (max-width: 743px) {
    margin-top: 24px;
  }
`;
